
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('rect',{staticClass:"cls-1",attrs:{"x":"41.22","y":"22.24","width":"65.96","height":"9.08","rx":"4.3"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M43.45 31.32h61.87v1.18a21.08 21.08 0 01-21.08 21.08h-19.7A21.08 21.08 0 0143.45 32.5v-1.18zM117.4 68.14a67.13 67.13 0 01-85.93 0M124.81 87.67a78.75 78.75 0 01-100.75 0M138 104.76a99.34 99.34 0 01-127.13 0"}})])
          )
        }
      }
    